// UTM tracking utilities for Facebook Pixel

// Save UTM parameters from URL to localStorage
export const saveUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  
  utmKeys.forEach(key => {
    const value = params.get(key);
    if (value) {
      localStorage.setItem(key, value);
    }
  });
};

// Get all UTM parameters from URL or localStorage
export const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  const utmParams = {};
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  
  utmKeys.forEach(key => {
    // First check URL params
    let value = params.get(key);
    
    // If not in URL, check localStorage
    if (!value) {
      value = localStorage.getItem(key);
    }
    
    if (value) {
      utmParams[key] = value;
    }
  });
  
  return utmParams;
};

// Track Facebook Pixel event with UTM parameters
export const trackEvent = (eventName, additionalParams = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    const utmParams = getUTMParams();
    const eventData = {
      ...additionalParams,
      ...utmParams
    };
    
    window.fbq('track', eventName, eventData);
  }
};

// Track ViewContent event
export const trackViewContent = (contentData = {}) => {
  trackEvent('ViewContent', contentData);
};

// Track Lead event
export const trackLead = (leadData = {}) => {
  trackEvent('Lead', leadData);
};

// Track CompleteRegistration event
export const trackCompleteRegistration = (registrationData = {}) => {
  trackEvent('CompleteRegistration', registrationData);
};

// Track Purchase event
export const trackPurchase = (purchaseData = {}) => {
  trackEvent('Purchase', purchaseData);
};

// Track AddToCart event
export const trackAddToCart = (cartData = {}) => {
  trackEvent('AddToCart', cartData);
};

// Track InitiateCheckout event
export const trackInitiateCheckout = (checkoutData = {}) => {
  trackEvent('InitiateCheckout', checkoutData);
};